import { render } from "./DialogOverlay.vue?vue&type=template&id=6d0711b7&ts=true"
import script from "./DialogOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogOverlay.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/dialog/DialogOverlay.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6d0711b7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d0711b7', __exports__)) {
    api.reload('6d0711b7', __exports__)
  }
  
  module.hot.accept("./DialogOverlay.vue?vue&type=template&id=6d0711b7&ts=true", () => {
    api.rerender('6d0711b7', render)
  })

}


export default __exports__